
/*/////////////////////////////////////////////////*/
import React from "react";
import { Link } from "react-router-dom";
import { vaultServices } from "../../libs/VaultServices";

/* Design assets */
import './DeviceInfo.css';
import { withStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import FormControl from '@material-ui/core/FormControl';
import FormHelperText from '@material-ui/core/FormHelperText';
import Lock from '@material-ui/icons/Lock';
import LockOpen from '@material-ui/icons/LockOpen';
import Button from '@material-ui/core/Button/Button';
import TextField from '@material-ui/core/TextField';
import CircularProgress from '@material-ui/core/CircularProgress';
import Fade from '@material-ui/core/Fade'; 
import TouchApp from '@material-ui/icons/TouchApp';
import Close from '@material-ui/icons/Close';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import Dialog from '@material-ui/core/Dialog';
import MuiDialogContent from '@material-ui/core/DialogContent';
import MuiDialogActions from '@material-ui/core/DialogActions';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';


/* DIALOG ASSET SETUP */
const DialogTitle = withStyles(theme => ({
  root: {
    borderBottom: `1px solid ${theme.palette.divider}`,
    margin: theme.spacing.unit * 2,
    padding: theme.spacing.unit * 2,
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing.unit,
    top: theme.spacing.unit,
    color: theme.palette.grey[500],
  },
}))(props => {
  const { children, classes, onClose } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root}>
      <Typography variant="body2">{children}</Typography>
      {onClose ? (
        <IconButton aria-label="Close" className={classes.closeButton} onClick={onClose}>
          <Close />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles(theme => ({
  root: {
    margin: 0,
    padding: theme.spacing.unit * 2,
  },
}))(MuiDialogContent);

const DialogActions = withStyles(theme => ({
  root: {
    borderTop: `1px solid ${theme.palette.divider}`,
    margin: 0,
    padding: theme.spacing.unit,
  },
}))(MuiDialogActions);
/* END */

const styles = theme => ({
  root: theme.mixins.gutters({
    paddingTop: 16,
    paddingBottom: 16,
    marginTop: theme.spacing.unit * 3,
    opacity: 0.9,    
  }),
  button: {
    margin: theme.spacing.unit + 15,
    // background: 'linear-gradient(45deg, #90CAF9 20%, #BBDEFB 90%)',
    backgroundColor: '#f44336',
    border: '1px solid black',
    fontSize: 16,
  },
  leftIcon: {
    marginRight: theme.spacing.unit,
  },
  rightIcon: {
    marginLeft: theme.spacing.unit,
  },
  
  textField: {
    marginLeft: theme.spacing.unit,
    marginRight: theme.spacing.unit,
    width: 200,     
  },
  textFieldInput: {
    fontSize: 16,
    },
  textFieldFormLabel: {
    fontSize: 16,    
  },
  placeholder: {
    height: 40
  },
  geo: {    
    fontSize: 14,
    marginLeft: theme.spacing.unit * 5,    
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing.unit,
    top: theme.spacing.unit,
    color: theme.palette.grey[500],
  },
  cancelButton: {
    float: 'right',    
    // color: 'red',
    // marginTop: theme.spacing.unit,
    padding: 0,
    backgroundColor: '#FF8A80',
    fontSize: 12,
  },
 
});
/* Design assets end */
/* ======================================================================================== */
class VaultInfo extends React.Component {
  constructor (props) {
    super(props)

    this.state = {   
      userId: "",
      token: "",
      loading: false,
      error: null,
      errorInfo: null,
      disabled: false,
      open: false,
      domainList: null,
      display: null,
      defaultMLImagePath: 'https://enterprise.masterlockvault.com/Images/',
      defaultImgExt: '.svg',     
    }
    this.handleChange = this.handleChange.bind(this);    
  }

  componentDidMount() {
    //AsyncStorage.getItem("user").then(user => {
    let user = sessionStorage.getItem("user");
      if (user) {
       // console.log(user);
        let x = JSON.parse(user);
        this.setState(() => ({
          userId: x.userId,
          token: x.token,
          orgId: x.orgId
        }));
      }          
  }

  handleClose = () => {
    this.setState({ open: false });
    this.props.history.push('/');
  };

  handleChange = name => event => {
      this.setState({
        [name]: event.target.value,
      });
      this.state = {        
        dynaFields:  event.target.value
       }
       this.props.handleChange({ dynaFields: this.state.dynaFields }); 
  };
 
  validate = () => {
    let isError = false;
    const errors = {
      vaultIdError: ""      
    };

    if (this.state.vaultId.length < 5) {
      isError = true;
      errors.vaultIdError = "Invalid Vault Id";
    }
   
    this.setState({
      ...this.state,
      ...errors
    });

    return isError;
  };

  onSubmit = async e => {
    e.preventDefault();
    
    const err = this.validate();

    if (!err) {

        this.setState({ loading: true });
        //console.log(this.state);
        let VaultData = await vaultServices.fetchVaultDetail(this.state.vaultId, this.state.userId, this.state.token, this.state.orgId);        
       
        //console.log(VaultData);
        
        if (VaultData.status !== 400) {
          this.setState({VaultData: VaultData});
          this.setState({open: true});       
          if(this.state.vaultIdError.length > 0){
            this.setState({vaultIdError:""});
          }
          this.setState({loading: false});
        } else {          
            this.setState({vaultIdError: 'WARNING:' + VaultData.data + '\nPlease contact your administrator'});        
            this.setState({loading: false});
            this.setState({open: false});
        }       
      }
  }  

  display(vault) {
   
    let details = Object.assign({}, vault.data.itemResult[0]);
    let classes = this.props;
    return (
            <List className={classes.root}>                                 
              <ListItem alignItems="flex-start">
                <ListItemText primary={<Typography style={{fontWeight:'bold'}}>Model</Typography>} 
                              secondary={<Typography>{details.model}</Typography>}  />
              </ListItem>                  
              <ListItem alignItems="flex-start">
                <ListItemText primary={<Typography style={{fontWeight:'bold'}}>Firmware</Typography>} 
                              secondary={<Typography>{details.firmware}</Typography>}  />
              </ListItem>                  
              <ListItem alignItems="flex-start">                
                <ListItemText primary={<Typography style={{fontWeight:'bold'}}>Physical Location</Typography>} 
                              secondary={<Typography>{details.physicalLocation}</Typography>}  />
              </ListItem>
            </List>        
    );
  }
  displayTitle(vault) { 
      let details = Object.assign({}, vault.data.itemResult[0]);      
      return (
              <Typography variant="body2" gutterBottom>
                <img src={this.state.defaultMLImagePath + details.model + this.state.defaultImgExt}
                    alt={details.model}
                    style={{verticalAlign: "middle"}}
                    width="60px"
                    height="60px" /> Details for {details.assetTag}     
              </Typography>     
      );
  }

/* ======================================================================================== */
  
  render() {   
    const { classes } = this.props; 
    const { loading } = this.state;   
    const { disabled } = this.state;
    const { VaultData } = this.state;

    /* END */   
    
    return (  
      
      <div className="wrapper">
       
      <Paper className={classes.root}>      
      <Button aria-label="Cancel" className={classes.cancelButton} onClick={this.handleClose}>Cancel</Button>  
                    
      <h4>
        <div>
              <Lock className={classes.leftIcon} />
              Vault Information
        </div>
      </h4>
      
      <div> 
        <form onSubmit={e => this.onSubmit(e)}>        
          <FormControl error aria-describedby="vaultId-error-text" >
          <TextField
            id="vaultId"
            label="Enter Vault Id"
            className={classes.textField}
            value={this.state.vaultId}
            onChange={this.handleChange('vaultId')}
            margin="normal" 
            required
            disabled={this.state.disabled}
            InputLabelProps={{            
              className: classes.textFieldFormLabel,
            }} 
            InputProps={{
              className: classes.textFieldInput,
            }} />
              <FormHelperText id="Vault-error-text" className={classes.textFieldFormLabel}><pre><strong>{this.state.vaultIdError}</strong></pre></FormHelperText>
            
            <Button className={classes.button} 
                    type="submit"  
                    disabled={loading}>              
              <TouchApp className={classes.leftIcon} />
              Vault Info
          
              {<Fade
                    in={loading}
                    style={{
                      transitionDelay: loading ? '800ms' : '0ms',
                    }}
                    unmountOnExit
                  >
                    <CircularProgress />
                  </Fade>}
            </Button>    </FormControl>     
        </form>
        </div>
      
      {/* results */}      
      <Dialog
          onClose={this.handleClose}
          aria-labelledby="customized-dialog-title"
          open={this.state.open}>
        <DialogTitle id="customized-dialog-title" onClose={this.handleClose}>
        {VaultData ?
                    (<React.Fragment>{this.displayTitle(VaultData)}</React.Fragment>)
                    : ""
        }
        </DialogTitle>
        <DialogContent>
          <Typography variant="body3" gutterBottom>
                  {VaultData ?
                    (<React.Fragment>{this.display(VaultData)}</React.Fragment>)
                    : ""
                  }
          </Typography>
        </DialogContent>
        <DialogActions>
              <Link to="/TempCodeRqst">
                <Button className={classes.button}   type="button"  disabled={disabled}>
                <LockOpen className={classes.leftIcon} />
                Temp Code&nbsp;
                {<Fade
                    in={loading}
                    style={{
                      transitionDelay: loading ? '800ms' : '0ms',
                    }}
                    unmountOnExit
                  >
                    <CircularProgress />
                  </Fade>}
                </Button>        
              </Link>    
        </DialogActions>
      </Dialog>
      </Paper>


      </div>      
     
    );
  }
}
export default withStyles(styles)(VaultInfo);


// WEBPACK FOOTER //
// ./src/containers/DeviceInfo/deviceinfo.js